module.exports = __webpack_public_path__ + "static/media/token-logo.png.79350896.old";